import { createContext, useContext, useMemo, useState } from "react";

const PublicCurrencyContext = createContext(null);

export function PublicCurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("ponderr_pub_ccy") || "INR");
  const change = (c) => { setCurrency(c); try { localStorage.setItem("ponderr_pub_ccy", c); } catch (e) {} };
  const value = useMemo(() => ({
    currency,
    setCurrency: change,
    symbol: currency === "USD" ? "$" : "₹",
    // Pick the right field from a plan doc given inr/usd numbers.
    pick: (inr, usd) => (currency === "USD" ? usd : inr),
    fmt: (inr, usd) => {
      const n = currency === "USD" ? usd : inr;
      const sym = currency === "USD" ? "$" : "₹";
      if (n == null || n === 0) return "Free";
      return `${sym}${Number(n).toLocaleString()}`;
    },
  }), [currency]);
  return <PublicCurrencyContext.Provider value={value}>{children}</PublicCurrencyContext.Provider>;
}

export function usePublicCurrency() {
  return useContext(PublicCurrencyContext) || { currency: "INR", setCurrency: () => {}, symbol: "₹", pick: (a) => a, fmt: (a) => (a ? `₹${a}` : "Free") };
}
